"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationStepperSetup = void 0;
var _services = require("../../services");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _constants = require("../../utils/constants");
var _useUpsellActions = require("../upsell/useUpsellActions");
var _useRecommendationActions = require("./useRecommendationActions");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _useComparisonSettings = _interopRequireDefault(require("../../hooks/comparison/useComparisonSettings"));
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useRecommendationStepperSetup = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    showUpsell
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUpsellSettings);
  const {
    isRecommendationStepperClickable
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const {
    isJourneyForHandset,
    isJourneyForPlan,
    isJourneyForHandsetAndPlan,
    isJourneyForBroadband,
    isJourneyForBusinessSolution
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  const isRecurringHandset = false;
  const {
    onNext: onNextRecommendation
  } = (0, _useRecommendationActions.useRecommendationActions)();
  const {
    onNext: onNextUpsell
  } = (0, _useUpsellActions.useUpsellActions)();
  const {
    showComparisonDevices,
    showComparisonPlans,
    showComparisonBroadbands,
    showComparisonBusinessSolution
  } = (0, _useComparisonSettings.default)();
  const ALL_STEPS = [{
    title: _services.Services.locale.localeString('RecommendationStepper.SelectDevice'),
    stepType: _constants.STEP_TYPES.HANDSET,
    showComparisonButton: showComparisonDevices,
    onNext: isRecurringHandset || isJourneyForPlan || isJourneyForHandsetAndPlan ? () => dispatch((0, _recommendationActions.showPlanRecommendation)()) : onNextRecommendation
  }, {
    title: _services.Services.locale.localeString('RecommendationStepper.SelectPlan'),
    showComparisonButton: false,
    onNext: isJourneyForPlan || isJourneyForHandsetAndPlan ? () => null : onNextRecommendation
  }, {
    title: _services.Services.locale.localeString('RecommendationStepper.SelectAirtimePlan'),
    stepType: _constants.STEP_TYPES.AIRTIME_PLAN,
    showComparisonButton: showComparisonPlans,
    onNext: onNextRecommendation
  }, {
    title: _services.Services.locale.localeString('RecommendationStepper.SelectBroadband'),
    stepType: _constants.STEP_TYPES.BROADBAND,
    showComparisonButton: showComparisonBroadbands,
    onNext: onNextRecommendation
  }, {
    title: _services.Services.locale.localeString('RecommendationStepper.SelectBroadband'),
    stepType: _constants.STEP_TYPES.BUSINESS_SOLUTION,
    showComparisonButton: showComparisonBusinessSolution,
    onNext: onNextRecommendation
  }];
  const OTHER_OPTIONS_STEP = {
    title: _services.Services.locale.localeString('RecommendationStepper.OtherOptions'),
    showComparisonButton: false,
    stepType: _constants.STEP_TYPES.UPSELL,
    onNext: onNextUpsell
  };
  const setupStepper = recommendationData => {
    const shownSteps = [isJourneyForHandset && ALL_STEPS[0], isRecurringHandset && ALL_STEPS[1], isJourneyForPlan && ALL_STEPS[2], isJourneyForBroadband && ALL_STEPS[3], isJourneyForBusinessSolution && ALL_STEPS[4], (showUpsell && !(isJourneyForPlan || isJourneyForBroadband) || showUpsell && isJourneyForHandsetAndPlan) && OTHER_OPTIONS_STEP].filter(step => step).map((step, index) => {
      const showComparisonBtnIfCan = Object.values(recommendationData).flat().length >= 2;
      step.showComparisonButton = step.showComparisonButton && showComparisonBtnIfCan;
      if (!isRecommendationStepperClickable) return step;
      return {
        ...step,
        onClick: () => {
          dispatch((0, _recommendationActions.setRecommendationStep)(index + 1));
        }
      };
    });
    dispatch((0, _recommendationActions.setRecommendationSteps)(shownSteps));
  };
  return {
    setupStepper
  };
};
exports.useRecommendationStepperSetup = useRecommendationStepperSetup;